import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {TableColumn, FieldType} from './table-column';
import {formatDate, formatNumber, formatDollar} from '../../../wc-converters/index';
import {TableCellEditText} from './editors/table-cell-edit-text';
import {TableCellEditNumber} from './editors/table-cell-edit-number';
import {Icon} from '../icon/icon';
import {TableAlert} from './table-alert';
import {TableBodyCell} from './table-body-cell';

require('../../../../icons/plussquareo.svg');
require('../../../../icons/minussquareo.svg');

Vue.config.keyCodes.f2 = 113;

@Component({
  template: require('./table-body.html'),
  name: 'wc-table-body',
  components: {
    'wc-table-cell-edit-text': TableCellEditText,
    'wc-table-cell-edit-number': TableCellEditNumber,
    'wc-icon': Icon,
    'table-body-cell': TableBodyCell
  }
})
export class TableBody extends Vue {
  @Prop()
  rowIdField: string;
  @Prop()
  data: Array<any>;
  @Prop()
  groupedData: Array<any>;
  @Prop()
  showColumns: Array<TableColumn>;
  @Prop()
  columns: Array<TableColumn>;
  @Prop()
  rowSelection: boolean;
  @Prop()
  expandedRowField: string;
  @Prop()
  expandedRowFormatter: (row: any) => string;
  @Prop()
  expandedRowComponent: string;
  @Prop()
  expandedRowComponentField: string;
  @Prop()
  rowClick: (row: any) => void;
  @Prop()
  rowDoubleClick: (row: any) => void;
  @Prop()
  rowClass: (row: any) => void;
  @Prop({
    default: 2
  })
  clicksToEdit: number;
  @Prop()
  navigatable: boolean;
  @Prop()
  navigation: boolean;
  @Prop()
  tableAlerts: Array<TableAlert>;

  delay = 500;
  clicks = 0;
  timer: number;
  expandedRows: Array<any> = [];
  groups: Array<any> = [];
  fieldType = FieldType;
  alert = false;
  

  // Current state
  navigationCell: TableNavigation | null = null;
  editingColumn: TableColumn | null = null;
  _editGroupIndex: number = 0;

  get displayColumns() : Array<TableColumn> {
    return (this.showColumns || this.columns).filter(column => column.group !== true && column.hidden !== true);
  }

  // return all visible columns 
  get visibleColumns() {
    return this.columns.filter(column => column.group !== true && column.hidden !== true);
  }

  get expandableRow(): boolean {
    return this.expandedRowField || this.expandedRowFormatter || this.expandedRowComponent ? true : false;
  }
  expandableRowField(row): boolean {
    if (this.expandedRowComponentField){
      return !!row[this.expandedRowComponentField];
    }
    return true;
  }

  get groupColumn(): any {
    return (this.showColumns || this.columns).find(column => column.group === true);
  }

  get expandableRowColumnSpan() {
    return this.displayColumns.filter(column => column.group !== true && column.hidden !== true).length + (this.rowSelection ? 1 : 0);
  }

  selectChange(index: any) {
    this.data.splice(index, 1, this.data[index]);
    this.$emit('selectChange');
  }

  onGroupClick(group) {
    group.expanded = !group.expanded;
  }

  onExpandableRowClick(row: any, index: any) {
    if (!this.expandableRow) return;

    let rowId = '';

    if (this.rowIdField) {
      rowId = row[this.rowIdField];
    } else {
      for (let property in row) {
        if (property !== '_rowId')
          rowId += `${property}=${row[property]};`;
      }
    }

    if (row._rowId === undefined) {
      row._rowId = rowId;
    }

    let expandedRowIndex = this.expandedRows.indexOf(rowId);
    if (expandedRowIndex === -1) this.expandedRows.push(rowId);
    else this.expandedRows.splice(expandedRowIndex, 1);
  }

  onRowClick(row: any, index: any) {
    if (!this.rowClick && !this.rowDoubleClick) return;

    this.clicks++;
    if(this.clicks === 1) {
      this.timer = window.setTimeout(() => {
        this.clicks = 0;
        if (this.rowClick) this.rowClick.call(this, row);
      }, this.delay);
    } else{
      clearTimeout(this.timer);  
      this.clicks = 0;
      if (this.rowDoubleClick) this.rowDoubleClick.call(this, row);
    }    
  }

  dataEdit(row, column) {
    this.$emit('dataEdit', row, column);
  }

  tableGroupData(group: any) {
    return group.pageData ? group.pageData : group.data;
  }

  updateNavigation(navigation: TableNavigation) {
    this.$emit('update:navigation', navigation);
  }
}



export interface TableNavigation {
  group: any;
  groupIndex: number;
  row: any;
  rowIndex: number;
  column: TableColumn;
  columnIndex: number;
  element?: HTMLTableCellElement;
}




// WEBPACK FOOTER //
// src/../~/wc-lib/src/wc-ui/components/table/table-body.ts